module.exports = __webpack_public_path__ + "static/media/L-4.75817684.svg";